import { render } from "./fields-layout.vue?vue&type=template&id=3884da48"
import script from "./fields-layout.vue?vue&type=script&lang=js"
export * from "./fields-layout.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./fields-layout.vue?vue&type=style&index=0&id=3884da48&module=true&lang=css"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./fields-layout.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__